// DS: C16A
/** An editor content viewer for comments */ import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import React from 'react';
import BaseViewer from './Base';
import commentsTheme from '../Themes/Viewer/comments.scss';
const CommentViewer = (props)=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: 'da-editor-comments'
    }, /*#__PURE__*/ React.createElement(BaseViewer, _object_spread({
        theme: commentsTheme,
        showMediaAlwaysSmall: true,
        fixedParagraph: false
    }, props)));
};
export default CommentViewer;
